module.exports = __webpack_public_path__ + "img/reserve.761e78c5.jpg";